///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import PricingGridHeader from "../pricing/PricingGridHeader";
import getPricingGridColumns from "../../../helpers/getPricingGridColumns";
import LanesGridBody from "../pricing/LanesGridBody";
import {
  setColumnOrder,
  toggleColumnFilterMenu,
  filterPricingLanes,
  setColumnWidth,
  sortPricingLanes
} from "../../../slices/laneMatchSlice";

export const MatchigGrid = ({ role, division, userDivision }) => {
  const {
    lanes,
    lanesLoading: loading,
    lanesError: error,
    offset,
    columns: { order: columnOrder },
    sortField,
    sortOrder,
    lanesLoading,
    columnFilterMenu,
    columnFilters,
    rangeFilters,
    columnWidths
  } = useSelector(state => state.laneMatch);
  const { summary } = useSelector(state => state.bidSummary);
  const columns = getPricingGridColumns(role, division, null, summary?.isCoyoteBid);

  return (
    <>
      <div className="table-width lane-match-container">
        {error || (
          <div style={{ maxHeight: 324 }} className="overflow-x--scroll scroll">
            <table
              id="lanes-match-grid"
              className="bg-white pl-16 pos-relative"
            >
              <PricingGridHeader
                columns={columns}
                role={role}
                columnOrder={columnOrder}
                isLaneMatch={true}
                setColumnOrder={setColumnOrder}
                toggleColumnFilterMenu={toggleColumnFilterMenu}
                filterPricingLanes={filterPricingLanes}
                setColumnWidth={setColumnWidth}
                sortPricingLanes={sortPricingLanes}
                sortField={sortField}
                sortOrder={sortOrder}
                lanesLoading={lanesLoading}
                columnFilterMenu={columnFilterMenu}
                columnFilters={columnFilters}
                rangeFilters={rangeFilters}
                columnWidths={columnWidths}
              />

              {!loading && lanes && (
                <LanesGridBody
                  columns={columns}
                  lanes={lanes}
                  offset={offset}
                  perPage={lanes.length}
                  role={role}
                  columnOrder={columnOrder}
                  disableDeleteButton={true}
                  isLaneMatch={true}
                  bidDivision={division}
                  userDivision={userDivision}
                />
              )}
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default MatchigGrid;
